import axios from "axios";
import {
  Coach,
  CoachesResponse,
  CreateCoachData,
  UpdateCoachData,
} from "../types/Coach";

const API_BASE_URL = "/api/coaches";

export const coachesApi = {
  // Get all coaches with pagination and search
  getAll: async (
    page: number = 1,
    limit: number = 10,
    search: string = ""
  ): Promise<CoachesResponse> => {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });

    if (search.trim()) {
      params.append("search", search.trim());
    }

    const response = await axios.get(`${API_BASE_URL}?${params.toString()}`);
    return response.data;
  },

  // Get coach by ID
  getById: async (id: string): Promise<Coach> => {
    const response = await axios.get(`${API_BASE_URL}/${id}`);
    return response.data.data;
  },

  // Get coach by phone number
  getByNumber: async (number: string): Promise<Coach> => {
    const response = await axios.get(`${API_BASE_URL}/number/${number}`);
    return response.data.data;
  },

  // Create new coach
  create: async (coachData: CreateCoachData): Promise<Coach> => {
    const response = await axios.post(API_BASE_URL, coachData);
    return response.data.data;
  },

  // Update coach
  update: async (id: string, coachData: UpdateCoachData): Promise<Coach> => {
    const response = await axios.put(`${API_BASE_URL}/${id}`, coachData);
    return response.data.data;
  },

  // Delete coach
  delete: async (id: string): Promise<void> => {
    await axios.delete(`${API_BASE_URL}/${id}`);
  },

  // Link coach to team
  linkTeam: async (coachId: string, teamId: string): Promise<void> => {
    await axios.post(`${API_BASE_URL}/link-team`, {
      coachId,
      teamId,
    });
  },
};
